import { api } from "../AxiosInstance";
import { body } from "./JobAssignmentService";

export interface FleetSuggestionCandidate {
  truckId: number; registrationNumber: string; driverId: number | null; driverName: string | null;
  baseStationId: number | null; baseStationName: string | null;
  telemetry: {battery?: number | null; metricsStale?: boolean; demo?: boolean} | null;
  pickupDistanceKm: number | null; totalRequiredDistanceKm: number | null;
  usableRangeWith15PercentReserveKm?: number | null;
  energy: {status: string; remainingRangeKm: number | null; usableRangeKm: number | null;
    batteryAtTripCompletionPercent: number | null; batteryAtBasePercent: number | null};
  rangeModelVersion: string | null;
  status: "SUFFICIENT" | "INSUFFICIENT" | "UNKNOWN" | "UNAVAILABLE" | "RESERVE_WARNING";
  reasons: string[];
}
export interface FleetSuggestionResponse {
  tripId: number; evaluatedAt: number; minimumBatteryAtBasePercent: number; fallbackTo15Percent?: boolean;
  suggestions: FleetSuggestionCandidate[]; otherCandidates: FleetSuggestionCandidate[];
}
export async function getFleetSuggestions(tripId: number, signal?: AbortSignal): Promise<FleetSuggestionResponse> {
  const result = body(await api.get(`/trip/assignments/${tripId}/suggestions`, {params: {limit: 3}, signal, timeout: 15000}));
  if (result?.tripId !== tripId || !Array.isArray(result?.suggestions) || !Array.isArray(result?.otherCandidates))
    throw new Error("Trailer suggestions could not be read. Please retry.");
  return result;
}
export function canUseSuggestion(candidate: FleetSuggestionCandidate, evaluatedAt: number, minimum: 15 | 20 = 20): boolean {
  const battery = candidate.energy?.batteryAtBasePercent;
  return (candidate.status === "SUFFICIENT" || minimum === 15 && candidate.status === "RESERVE_WARNING") && candidate.driverId != null && typeof battery === "number"
    && Number.isFinite(battery) && battery >= minimum && !candidate.telemetry?.metricsStale && !candidate.telemetry?.demo
    && Number.isFinite(evaluatedAt) && evaluatedAt <= Date.now() + 5000 && evaluatedAt >= Date.now() - 45000;
}
